// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._72RGnOA5p3LBvr1TZjpUMw\\=\\={background:radial-gradient(ellipse at bottom,#ddffc9 0,#56db96 35%) bottom /400% 200%}.FMTODnioAx62kjzv-rnCpA\\=\\={animation:_4ViLsowGXzA2tWA3RmraLQ\\=\\= 5s ease-out infinite;background-color:#56db96}@keyframes _4ViLsowGXzA2tWA3RmraLQ\\=\\={40%{background-color:transparent}80%{background-color:#56db96}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reborn": "_72RGnOA5p3LBvr1TZjpUMw==",
	"reborn2": "FMTODnioAx62kjzv-rnCpA==",
	"changeThatBackgroundOpacity": "_4ViLsowGXzA2tWA3RmraLQ=="
};
module.exports = ___CSS_LOADER_EXPORT___;
